import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { AdminShell } from "./AdminShell";
import { OverviewSection } from "./OverviewSection";
import { PropertiesSection } from "./PropertiesSection";
import { BookingsSection } from "./BookingsSection";
import { PaymentsSection } from "./PaymentsSection";
import { PasswordDialog } from "./PasswordDialog";
import { SiteSettingsSection } from "./SiteSettingsSection";
import { ToursAdmin } from "./ToursAdmin";
import { BackupsSection } from "./BackupsSection";
import { CouponsAdmin } from "./CouponsAdmin";
import { AddonsAdmin } from "./AddonsAdmin";
import { ReviewsPanel } from "@/components/admin/ReviewsPanel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const crud = (base, reload) => ({
  add: async (payload) => {
    try { await axios.post(`${API}/${base}`, payload); toast.success("Adicionado."); await reload(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro ao salvar"); }
  },
  update: async (id, payload) => {
    try { await axios.patch(`${API}/${base}/${id}`, payload); toast.success("Salvo."); await reload(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro ao salvar"); }
  },
  del: async (id) => {
    try { await axios.delete(`${API}/${base}/${id}`); toast.success("Removido."); await reload(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro ao remover"); }
  },
});

export default function LoqueAdmin({ user, onLogout }) {
  const [data, setData] = useState({ properties: [], bookings: [], reviews: [], tours: [], coupons: [], addons: [], cfg: null });
  const [pwdOpen, setPwdOpen] = useState(false);

  const load = useCallback(async () => {
    try {
      const [p, b, r, c, t, cp, ad] = await Promise.all(["properties", "bookings", "reviews", "config", "tours", "coupons", "addons"].map((k) => axios.get(`${API}/${k}`)));
      setData({ properties: p.data, bookings: b.data, reviews: r.data, cfg: c.data, tours: t.data, coupons: cp.data, addons: ad.data });
    } catch {}
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [load]);

  const props = crud("properties", load);
  const books = crud("bookings", load);
  const revs = crud("reviews", load);
  const trs = crud("tours", load);
  const cps = crud("coupons", load);
  const ads = crud("addons", load);
  const counts = { reservas: data.bookings.filter((b) => b.status === "pendente").length };

  return (
    <AdminShell user={user} onLogout={onLogout} counts={counts}>
      <PasswordDialog open={pwdOpen} onOpenChange={setPwdOpen} onLogout={onLogout} />
      <OverviewSection user={user} {...data} />
      <PropertiesSection items={data.properties} onAdd={props.add} onUpdate={props.update} onDelete={props.del} />
      <AddonsAdmin items={data.addons} onAdd={ads.add} onUpdate={ads.update} onDelete={ads.del} />
      <ToursAdmin items={data.tours} onAdd={trs.add} onUpdate={trs.update} onDelete={trs.del} />
      <CouponsAdmin items={data.coupons} onAdd={cps.add} onUpdate={cps.update} onDelete={cps.del} />
      <BookingsSection items={data.bookings} onUpdate={books.update} onDelete={books.del} />
      <ReviewsPanel items={data.reviews} onAdd={revs.add} onUpdate={revs.update} onDelete={revs.del} />
      <SiteSettingsSection />
      <PaymentsSection cfg={data.cfg} onSaved={load} onChangePassword={() => setPwdOpen(true)} />
      <BackupsSection />
    </AdminShell>
  );
}
